import { el, VNode } from "@dhx/ts-common/dom";
import { IImgOrgCardConfig } from "@dhx/ts-diagram";
import { Card } from "./Card";
import locale from "../../locales/en";
import { getMeta } from "../../helpers/baseMetaInfo";

export class ImgCard extends Card {
	public getMetaInfo(): { [key: string]: string }[] {
		return getMeta([
			{ type: "grid", label: locale.gridStep },
			{ type: "color", label: locale.color },
			{ type: "position", label: locale.position },
			{ type: "size", label: locale.size },
			{ type: "title", label: locale.title },
			{ type: "text", label: locale.text },
			{ type: "img", label: locale.image },
		]);
	}
	protected setDefaults(config: IImgOrgCardConfig, defaults?: IImgOrgCardConfig): IImgOrgCardConfig {
		const { width, height, text, title, headerColor, fixed } = config;

		const widthDefaut = defaults.width ? parseFloat(defaults.width as any) : 210;
		const heightDefault = defaults.height ? parseFloat(defaults.height as any) : 90;

		config.width = width || widthDefaut;
		config.height = height || heightDefault;
		config.title = typeof title === "string" ? title : defaults.title || "";
		config.text = typeof text === "string" ? text : defaults.text || "";
		config.headerColor = headerColor || defaults.headerColor || "";

		config.fixed = fixed || false;
		config.editable = typeof config.editable === "boolean" ? config.editable : true;

		return config;
	}
	protected getCss(): string {
		return "dhx_diagram_image " + super.getCss();
	}
	protected getContent(): VNode {
		const { img, headerColor, title, text, width, $editable } = this.config;
		const src = img ? `${img}` : null;
		return [
			el("img.dhx_orgcard__img", {
				style: {
					backgroundColor: img ? null : headerColor,
				},
				src,
			}),
			el(
				"div.dhx_orgcard__title.dhx_diagram_item__title",
				$editable && this.editableProperty.key === "title" ? [this.getEditorNode()] : title
			),
			el(
				"div.dhx_orgcard__text.dhx_diagram_item__text ",
				{
					class: `${title ? "" : "dhx_content_text-alone"}`,
					style: {
						maxWidth: width - 80,
						marginLeft: 80,
					},
				},
				$editable && this.editableProperty.key === "text" ? [this.getEditorNode()] : text
			),
		];
	}
}
